import {useLocation} from 'react-router-dom';
import ceremonyRoutes from '../setup/ceremonyRoutes';
import {CEREMONY_PATH} from '@constants';

/**
 * Extracts the relative ceremony path from full pathname.
 * E.g. "/transaction/123/ceremony/2fa/sms" -> "2fa/sms"
 */
function getRelativeCeremonyPath(pathname) {
    const ceremonyIndex = pathname.indexOf(CEREMONY_PATH);
    if (ceremonyIndex === -1) {
        return null;
    }
    const relativePath = pathname.slice(ceremonyIndex + CEREMONY_PATH.length + 1);
    return relativePath || null;
}

/**
 * Hook to get the current ceremony route configuration.
 * Matches current pathname against ceremonyRoutes using relative path.
 *
 * @returns {Object|undefined} The matched ceremony route config containing:
 *   - path: string - Route path
 *   - isLeftMenuVisible: boolean|undefined - Whether left menu should be visible
 *   - titleKey: string - i18n key for title
 *   - Icon: Component - Icon for the route
 *   - ...other route-specific properties
 */
export function useCeremonyRoute() {
    const location = useLocation();
    const relativePath = getRelativeCeremonyPath(location.pathname);

    if (!relativePath) {
        return undefined;
    }

    const foundRoute = ceremonyRoutes.find((route) =>
        relativePath === route.path || relativePath.startsWith(`${route.path}/`)
    );

    return foundRoute;
}
